import {Button} from "antd";
import i18next from "i18next";
import React, {useState} from "react";
import * as MfaBackend from "../../backend/MfaBackend";

// Enables the verified MFA method, keeping its first recovery code
export function requestMfaEnable({user, mfaType, secret, recoveryCodes, dest, countryCode}) {
  const data = {
    mfaType,
    secret,
    dest,
    countryCode,
    ...user,
  };
  data["recoveryCodes"] = recoveryCodes[0];
  return MfaBackend.MfaSetupEnable(data);
}

export function MfaEnableForm({user, mfaType, secret, recoveryCodes, dest, countryCode, onSuccess, onFail}) {
  const [loading, setLoading] = useState(false);
  const requestEnableMfa = () => {
    setLoading(true);
    requestMfaEnable({user, mfaType, secret, recoveryCodes, dest, countryCode}).then(res => {
      if (res.status === "ok") {
        onSuccess(res);
      } else {
        onFail(res);
      }
    }
    ).finally(() => {
      setLoading(false);
    });
  };

  return (
    <div style={{width: "400px"}}>
      <p>{i18next.t("mfa:Please save this recovery code. Once your device cannot provide an authentication code, you can reset mfa authentication by this recovery code")}</p>
      <br />
      <code style={{fontStyle: "solid"}}>{recoveryCodes[0]}</code>
      <Button style={{marginTop: 24}} loading={loading} onClick={() => {
        requestEnableMfa();
      }} block type="primary">
        {i18next.t("general:Enable")}
      </Button>
    </div>
  );
}

export default MfaEnableForm;
